import { render, staticRenderFns } from "./SearchRobot.vue?vue&type=template&id=66411403&scoped=true&"
import script from "./SearchRobot.vue?vue&type=script&lang=js&"
export * from "./SearchRobot.vue?vue&type=script&lang=js&"
import style0 from "./SearchRobot.vue?vue&type=style&index=0&id=66411403&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66411403",
  null
  
)

export default component.exports